document.addEventListener('DOMContentLoaded', () => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const categoryPath = document.querySelector('.kb-results__path');
  const toolbar = document.querySelector('.kb-results__toolbar');
  const sidebar = document.querySelector('.kb-search__layout > .kb-filters');
  const summary = document.querySelector('.kb-results__summary');
  const sort = document.querySelector('.kb-results__sort');
  const layout = document.querySelector('.kb-search__layout');
  if (!categoryPath || !toolbar || !sidebar || !layout) return;
  const controls = document.createElement('div');
  controls.className = 'kb-mobile-controls kb-mobile-controls--disclosure';
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'kb-mobile-filter-toggle';
  sidebar.id ||= 'KleverMobileFilters';
  toggle.setAttribute('aria-controls', sidebar.id);
  const setOpen = (open) => {
    sidebar.classList.toggle('is-mobile-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Cerrar filtros −' : 'Filtrar productos +';
  };
  setOpen(false);
  toggle.addEventListener('click', () => setOpen(!sidebar.classList.contains('is-mobile-open')));
  sidebar.addEventListener('keydown', (event) => {
    if (mobileQuery.matches && event.key === 'Escape') {
      setOpen(false);
      toggle.focus();
    }
  });
  const position = () => {
    if (document.querySelector('[data-filter-layout="category"]')) return;
    const tools = toolbar.querySelector('.kb-results__tools');
    if (mobileQuery.matches) {
      layout.prepend(categoryPath);
      categoryPath.classList.add('is-mobile-detached');
      if (summary) categoryPath.append(summary);
      categoryPath.after(controls);
      controls.append(toggle);
      if (sort) controls.append(sort);
      controls.append(sidebar);
      toolbar.classList.add('is-mobile-empty');
    } else {
      toolbar.prepend(categoryPath);
      categoryPath.classList.remove('is-mobile-detached');
      toolbar.classList.remove('is-mobile-empty');
      if (summary) tools?.prepend(summary);
      if (sort) tools?.append(sort);
      layout.prepend(sidebar);
      controls.remove();
    }
  };
  position();
  mobileQuery.addEventListener('change', position);
});
